/**
 * Shared `<svg>` frame for the mega-menu illustrations — a flat 220×130 canvas,
 * decorative (hidden from assistive tech). Pass the illustration's shapes as
 * children.
 */
export function IllustrationSvg({ children }: { children: React.ReactNode }) {
  return (
    <svg viewBox="0 0 220 130" width="100%" aria-hidden focusable="false">
      {children}
    </svg>
  );
}
